var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:_vm.badgeClasses},[_vm._v("\n    "+_vm._s(_vm.badgeText)+"\n  ")]),_vm._v(" "),(_vm.isPermanentBounce)?_c('span',{staticClass:"badge badge-secondary"},[_vm._v("\n    Permanent Bounce\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fc1ee96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailRecipientStatusBadge.vue
// module id = 1173
// module chunks = 1